import React from 'react';
import _ from 'lodash';
import history from 'app/routes/history';
import classnames from 'classnames';
import { parseAmount, formatAmount } from 'app/utils/parsers';
import Button from 'app/components/general/Button';
import TeamMembersTableSelectableAmounts, { ITeamMemberRow } from 'app/components/teamMembers/TeamMembersTableSelectableAmounts';

interface IStep2SelectTeamMembersProps {
  actions: any;
  organisations: any;
  organisationTags: any;
  teamMembers: any;
  match: any;
  teams: any;
  totalAmount: { amount: number; amountDeducted: number; amountTotal: number };
  splitType: string;
  defaultAmount: string;
  appReady: boolean;
  updateSelectedRows: Function;
  handleChangePayeeType: Function;
  selectedRows: any;
  selectedRowIds: string[];
  selectRow: Function;
  selectAllRows: Function;
  selectedAllRows: boolean;
  removeRow: Function;
  removeAllRows: Function;
  handleAmountChange: Function;
  handleQuantityChange: Function;
  rows: { [key: string]: ITeamMemberRow };
  rowsSelected: { [key: string]: boolean };
}

export default class Step2SelectTeamMembers extends React.Component<IStep2SelectTeamMembersProps> {
  static defaultProps: IStep2SelectTeamMembersProps = {
    actions: undefined,
    organisations: undefined,
    organisationTags: undefined,
    teamMembers: undefined,
    teams: undefined,
    match: undefined,
    totalAmount: undefined,
    defaultAmount: undefined,
    appReady: false,
    updateSelectedRows: undefined,
    handleChangePayeeType: undefined,
    selectedRows: undefined,
    selectedRowIds: [],
    selectRow: undefined,
    selectAllRows: undefined,
    selectedAllRows: undefined,
    removeRow: undefined,
    removeAllRows: undefined,
    handleAmountChange: undefined,
    handleQuantityChange: undefined,
    splitType: undefined,
  };

  componentDidMount = () => {
    if (this.props.defaultAmount === undefined) {
      history.push(`/payment-requests/new:${this.props.match.params.preconfigData}`);
    }
  }

  handleBack = () => {
    history.push(`/payment-requests/new:${this.props.match.params.preconfigData}`);
  };

  render(): React.ReactNode {
    return (
      <div className="">
        <div className="row">
          <div className="col">
            {this.props.children}
          </div>
        </div>
        <div className="row with-margin-top-extra">
          <div className="col">
            <TeamMembersTableSelectableAmounts
              headerTitle="Select Team Members"
              appReady={this.props.appReady}
              actions={this.props.actions}
              teamMemberIds={this.props.teamMembers.teamMemberIds}
              teamMembersById={this.props.teamMembers.teamMembersById}
              selectedRows={this.props.selectedRows}
              selectedRowIds={this.props.selectedRowIds}
              selectRow={this.props.selectRow}
              selectAllRows={this.props.selectAllRows}
              selectedAllRows={this.props.selectedAllRows}
              splitType={this.props.splitType}
              tableState={{
                selectedAllRows: this.props.selectedAllRows,
              }}
              rows={this.props.rows}
              rowsSelected={this.props.rowsSelected}
              removeRow={this.props.removeRow}
              removeAllRows={this.props.removeAllRows}
              pagination={this.props.teamMembers.pagination}
              isLoading={this.props.teamMembers.isLoading}
              updateSelectedRows={this.props.updateSelectedRows}
              manual
              filterable
              handleAmountChange={this.props.handleAmountChange}
              handleQuantityChange={this.props.handleQuantityChange}
            />
          </div>
        </div>

        <div className="row with-margin-top">
          <div className="col">
            <div className="row">
              <div className="col">
                Collecting a total of
                {' '}
                <span className="text-weight-bold">{parseAmount(this.props.totalAmount?.amount)}</span>
              </div>

            </div>
            <div className="row with-margin-top">
              <div className={classnames('col', { 'd-none': !this.props.rows?.teamManager?.selected })}>
                <span className="text-weight-bold">{parseAmount(this.props.totalAmount?.amountTotal)}</span>
                {' '}
                minus
                {' '}
                <span className="text-weight-bold">{parseAmount(this.props.totalAmount?.amountDeducted)}</span>
                {' '}
                (team manager deduction)
              </div>
            </div>
          </div>
          <div className="col btn-flex-group">
            <div className="btn-flex-container">
              <Button
                className="btn-standard btn-1"
                type="submit"
                noLoading
                disabled={_.filter(this.props.rows, 'selected').length === 0}
                onClick={() => {
                  history.push(`/payment-requests/new/confirm:${this.props.match.params.preconfigData}`);
                }}
              >
                Next
              </Button>
              <Button onClick={this.handleBack} className="btn-standard btn-2">Back</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
